import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MemberService } from '@app/services/member.service';
import createAutoCorrectedDatePipe from 'text-mask-addons/dist/createAutoCorrectedDatePipe';
import { SortService } from '@app/components/sorting/SortService';
import { InstitutionsService } from '@app/services/institutions/institutions.service';
import { SnackbarService } from '@app/services/shared/snackbar.service';
import { Subscription } from 'rxjs';
import moment from 'moment';
import { Router } from '@angular/router';
import { ConfirmationService } from 'primeng/api';
@Component({
  selector: 'app-changeprimaryinstitution',
  templateUrl: './changeprimaryinstitution.component.html'
})

export class ChangeprimaryinstitutionComponent implements OnChanges, OnDestroy, OnInit {
  @Input() memberid: number;
  @Input() givenname: string;
  @Input() familyname: string;
  @Input() primarylodgeformember: number;
  @Output() closeChange: EventEmitter<any> = new EventEmitter();

  institutions;
  exitcauses;
  subscriptions: Subscription[] = [];
  primaryinstitution;
  minmaxyear = { minYear: '1920', maxYear: '2030' };
  autoCorrectedDatePipe = createAutoCorrectedDatePipe('yyyy-mm-dd', this.minmaxyear);
  public maskdatum = [/[129]/, /[?09]/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/];
  changeprimaryinstitutionform;

  constructor(
    private router: Router,
    private fb: FormBuilder,
    private memberService: MemberService,
    private institutionsService: InstitutionsService,
    private confirmationService: ConfirmationService,
    private snackbarService: SnackbarService) { }

    ngOnInit(): void {
      this.changeprimaryinstitutionform = this.fb.group({
        memberId: ['', ''],
        fromInstitutionId: ['', ''],
        fromDate: ['', Validators.required],
        toInstitutionId: ['', Validators.required],
        causeId: ['', Validators.required]
      });
    }
    
  close() {
    this.closeChange.emit();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes && this.changeprimaryinstitutionform) {
      this.changeprimaryinstitutionform.get('memberId').setValue(this.memberid.toString());
      this.changeprimaryinstitutionform.get('fromInstitutionId').setValue(this.primarylodgeformember.toString());
    }
    this.subscriptions.push(this.institutionsService.GetAllPrimaryLodgesAsync(0).subscribe(response => {
      if (response) {
        this.institutions = response.sort((a, b) => {
          return SortService.cmpStringsWithNumbers(a.shortName, b.shortName, false);
        });
        const removelist = ['AV1', 'UT1', 'AVGBREV1', 'SOFT1', 'SOFT2'];
        this.institutions = this.institutions.filter(x => {
          return removelist.indexOf(x.shortName) === -1;
        });
        const idx = this.institutions.findIndex(i => i?.name === this.primaryinstitution?.name);
        if (idx !== -1) {
          this.institutions.splice(idx, 1);
        }
      }
    }));

    this.subscriptions.push(this.institutionsService.getEntryExitCauses().subscribe(response => {
      if (response) {
        this.exitcauses = response;
      }
    }));
    if (this.primarylodgeformember) {
      this.institutionsService.getInstitutionNameInfoAsync(this.primarylodgeformember).subscribe(response => {
        if (response) {
          this.primaryinstitution = response;
          this.changeprimaryinstitutionform.get('fromInstitutionId').setValue(this.primaryinstitution.id);
        }
      });
    }
  }

  ngOnDestroy() {
    this.subscriptions.forEach(sub => {
      sub.unsubscribe();
    });
  }

  confirmDialog(): void {
     this.confirmationService.confirm({
      header: 'Bekräftelse',
      message: 'Vill du byta primärinstitution ?',
      acceptLabel: 'Ja',
      rejectLabel: 'Nej',
      accept: () => {
        this.save();
      },
      reject: () => {
      }
    });
  }

  save() {
    this.changeprimaryinstitutionform.patchValue({ fromDate: moment(this.changeprimaryinstitutionform.get('fromDate').value).add(3, 'h').format('YYYY-MM-DD HH:mm') });
    this.memberService.ChangePrimaryInstitution(this.changeprimaryinstitutionform.value).subscribe(response => {
      if (response) {
        if (response === 'Ok') {
          this.snackbarService.openSnackBar('Primärinstitution bytt', null);
          this.router.onSameUrlNavigation = 'reload';
          this.router.navigateByUrl('/memberform/id/' + this.memberid);
          this.close();
        }
      }
    });
  }
}
